import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-scroll";
import { BlogsSlider } from "../../Slider/BlogsSlider";
import { API } from "../../api";
import Testimonial from "../../home/Testimonial";
import Offers from "../../products/Offers";
import WhyChose from "../../products/WhyChose";
import "../../products/product.css";

const blogs = [
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
];

const OpportunitiesPortfolio = () => {
  const pathRef = useRef(null);
  const heroRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeCard, setActiveCard] = useState(null);
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Fetch product data from API
  const fetchProductData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API}/api/product-cop`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch product data");
      }

      const data = await response.json();
      setProductData(data);

      // Set initial active card after data is loaded
      if (data.analyticalFramework?.cards?.[0]) {
        setActiveCard(data.analyticalFramework.cards[0]);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get media URL
  const getMediaUrl = (imageId) => {
    if (!imageId) return "";
    return `${API}/api/media/${imageId}`;
  };

  useEffect(() => {
    fetchProductData();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // SVG Path Animation
  useEffect(() => {
    const path = pathRef.current;
    if (!path) return;

    const pathLength = path.getTotalLength();
    path.style.strokeDasharray = pathLength;
    path.style.strokeDashoffset = pathLength;

    const animatePath = () => {
      path.style.transition = "stroke-dashoffset 5s ease-in-out";
      path.style.strokeDashoffset = "0";

      setTimeout(() => {
        // Reset animation
        path.style.transition = "none";
        path.style.strokeDashoffset = pathLength;

        // Small delay before restarting
        setTimeout(() => {
          path.style.transition = "stroke-dashoffset 5s ease-in-out";
          path.style.strokeDashoffset = "0";
        }, 100);
      }, 5000);
    };

    // Run animation loop continuously, regardless of visibility
    const interval = setInterval(animatePath, 7000); // 5s animation + 3s delay

    animatePath(); // Start immediately

    return () => clearInterval(interval); // Cleanup on unmount
  }, [pathRef.current]);

  // Intersection Observer for hero section
  useEffect(() => {
    if (loading || !heroRef.current) return;

    const heroBg = document.querySelector(".heroBg2");
    const herotext = document.querySelector(".heroText");

    if (!heroBg || !herotext) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          heroBg.classList.add("active");
          setTimeout(() => {
            herotext.classList.add("active");
          }, 1000);
        } else {
          herotext.classList.remove("active");
          setTimeout(() => {
            heroBg.classList.remove("active");
          }, 500);
        }
      },
      { rootMargin: "0px", threshold: 0.3 }
    );

    observer.observe(heroRef.current);

    return () => {
      observer.disconnect();
    };
  }, [loading]);

  const handleCardClick = (card) => {
    setActiveCard(card);
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "200px" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error && !productData) {
    return (
      <div className="alert alert-warning m-3" role="alert">
        Error loading product data: {error}
      </div>
    );
  }

  // Safe data access with fallbacks
  const {
    pageData = {},
    heroSection = {},
    offersSection = {},
    analyticalFramework = {},
    investmentStrategy = {},
    whyChooseSection = {},
  } = productData || {};

  const safePageData = {
    title: {
      normalText: pageData.title?.normalText || "Credit",
      highlightedText: pageData.title?.highlightedText || " Opportunities ",
      normalText2: pageData.title?.normalText2 || "Portfolio",
    },
    subtitle:
      pageData.subtitle || "Invest where your bank invests — and earn more",
    description:
      pageData.description ||
      "You want your capital to grow—but not at the cost of sleepless nights. When yields go up, so do questions about safety",
    text: pageData.text || "Where your capital earns more—",
    highlightedText:
      pageData.highlightedText || "without compromising quality.",
    buttonText: pageData.buttonText || "Know More",
    buttonLink: pageData.buttonLink || "/about-us",
  };

  const safeHeroSection = {
    comparisons: heroSection.comparisons || [],
    conclusion: {
      question: heroSection.conclusion?.question || {
        normalText: "So how do you earn ",
        highlightedText: "double-digit returns",
        normalText2:
          " —without giving your money to someone you'd never lend to personally?",
      },
      highlightedAnswer:
        heroSection.conclusion?.highlightedAnswer ||
        "That's where the Credit Opportunities Portfolio (COP) comes in.",
      description:
        heroSection.conclusion?.description ||
        "It brings the same research discipline used in equities into the world of fixed income—targeting high-quality issuers with smart structures and credible yield potential.",
    },
  };

  const safeOffersSection = {
    title: offersSection.title || "Our Offering",
    subtitle: {
      text: offersSection.subtitle?.text || "Investment",
      highlight: offersSection.subtitle?.highlight || "Strategy",
    },
    offers: offersSection.offers || [],
  };

  const safeAnalyticalFramework = {
    mainTitle: {
      normalText:
        analyticalFramework.mainTitle?.normalText || "What goes into ",
      highlightedText:
        analyticalFramework.mainTitle?.highlightedText || "COP's 360-degree",
      normalText2:
        analyticalFramework.mainTitle?.normalText2 || " analytical approach?",
    },
    cards: analyticalFramework.cards || [],
    footerText:
      analyticalFramework.footerText ||
      "THIS 360-DEGREE LENS ENSURES WE DON'T JUST CHASE YIELD—WE INVEST WITH CONVICTION, CLARITY, AND RISK CONTROL",
  };

  const safeInvestmentStrategy = {
    title: {
      normalText: investmentStrategy.title?.normalText || "Have you assumed ",
      highlightedText:
        investmentStrategy.title?.highlightedText || "fixed income",
      normalText2:
        investmentStrategy.title?.normalText2 ||
        " means passively sitting and waiting for moderate returns?",
    },
    strategies: investmentStrategy.strategies || [],
    conclusionBox: {
      title: investmentStrategy.conclusionBox?.title || "It doesn’t have to",
      description:
        investmentStrategy.conclusionBox?.description ||
        "COP is an actively managed strategy that makes tactical calls based on:",
      text1:
        investmentStrategy.conclusionBox?.text1 ||
        "This is fixed income done right—",
      text2:
        investmentStrategy.conclusionBox?.text2 ||
        "dynamic, credit-conscious, and yield-focused.",
      text3:
        investmentStrategy.conclusionBox?.text3 ||
        "Build a smarter fixed income core. Backed by credit rigour and tactical thinking.",
      buttonText: investmentStrategy.conclusionBox?.buttonText || "Know More",
    },
  };

  const safeWhyChooseSection = {
    titleHeading: {
      text: whyChooseSection.titleHeading?.text || "Why Choose",
      highlight: whyChooseSection.titleHeading?.highlight || "Ladderup?",
    },
    items: whyChooseSection.items || [],
  };

  return (
    <div>
      {/* Hero Section */}
      <div className="row m-0 p-0 pageBg">
        <div className="col-md-6 d-flex align-items-end justify-content-center">
          <div className="col-11 text-start" data-aos="zoom-in-up">
            <p className="fs-1 fw-bold line-height-1 mb-2">
              {safePageData.title.normalText}
              <span className="org">{safePageData.title.highlightedText}</span>
              {safePageData.title.normalText2}
            </p>
            <p className="tJustify fw-bold mb-3">{safePageData.subtitle}</p>
            <p className="tJustify fs-5 mb-3">{safePageData.description}</p>
            <p className="tJustify fs-3">{safePageData.text}</p>
            <p className="tJustify org fw-bold fs-3">
              {safePageData.highlightedText}
            </p>
            <button
              className="buttonEffect mb-2"
              onClick={() => navigate(safePageData.buttonLink)}
            >
              {safePageData.buttonText}
            </button>
          </div>
        </div>
        <div className="col-md-6 d-flex align-items-end justify-content-end">
          <div className="col-md-10 col-12">
            <svg
              id="mySvg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="auto"
              viewBox="0 0 869 832"
              fill="none"
              class="mt-4"
            >
              <path
                ref={pathRef}
                id="myPath"
                d="M35.5 832V627.5H232V427H446.5V233H651.5V35H868.5"
                stroke="#F47024"
                strokeWidth="70"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Hero Background Section */}
      <div className="productHero" ref={heroRef}>
        <div className="heroBg2"></div>
        <div className="heroText d-flex align-items-center">
          <div className="col-11">
            <div className="">
              {safeHeroSection.comparisons.map((comparison, index) => (
                <div
                  key={index}
                  className="border product-padding-card boredr-color-wrapper mt-4"
                >
                  <p className="fs-1">{comparison.question}</p>
                  <p className="fs-2 org">{comparison.answer}</p>
                </div>
              ))}
            </div>
            <div className="border p-4 mt-4">
              <p className="fs-4">
                {safeHeroSection.conclusion.question.normalText}
                <span className="org">
                  {safeHeroSection.conclusion.question.highlightedText}
                </span>
                {safeHeroSection.conclusion.question.normalText2}
              </p>
              <p className="fs-4 org mt-5 mb-5 font-italic">
                {safeHeroSection.conclusion.highlightedAnswer}
              </p>
              <p className="fs-4">{safeHeroSection.conclusion.description}</p>
            </div>
            <br />
          </div>
        </div>
      </div>

      {/* Offers Section */}
      <div>
        <div className="col-11 m-auto mt-5">
          <p>{safeOffersSection.title}</p>
          <p className="fs-1">
            {safeOffersSection.subtitle.text}{" "}
            <span className="fw-semibold org">
              {safeOffersSection.subtitle.highlight}
            </span>
          </p>
          <div className="offerMobile">
            <div className="row mt-4 h-100">
              {safeOffersSection.offers.map((offer, index) => (
                <div key={index} className="col-lg-4 col-md-6 mt-4">
                  <div className="col-11 m-auto text-start p-3 investCart">
                    <p className="fs-3 fw-semibold">{offer.title}</p>
                    <div className="my-5">
                      <br />
                    </div>
                    {offer.points &&
                      offer.points.map((point, pointIndex) => (
                        <p key={pointIndex} className="fs-5">
                          {point}
                        </p>
                      ))}
                    {offer.buttonName && (
                      <button
                        className="buttonEffect mt-3"
                        onClick={() => navigate("/contact-us")}
                      >
                        {offer.buttonName}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="offerPc">
            <Offers offers={safeOffersSection.offers} />
          </div>
        </div>
      </div>

      {/* Analytical Framework Section */}
      <div className="col-11 m-auto my-5">
        <div className="row mb-5 justify-content-center">
          <div className="col-12 col-md-5 col-lg-4 mb-4 mb-md-0">
            <div className="row mb-5">
              <div className="col-12 text-center text-md-center">
                <h2 className="fw-bold">
                  {activeCard?.leftTitle ||
                    "Do you worry that higher yields will always come with higher risk?"}
                </h2>
                <p className="lead fst-italic mt-3">
                  {activeCard?.leftSubtitle || "~Not if you choose right."}
                </p>
              </div>
            </div>
            <h4 className="fw-bold fs-4">
              {safeAnalyticalFramework.mainTitle.normalText}
              <span className="org">
                {safeAnalyticalFramework.mainTitle.highlightedText}
              </span>
              {safeAnalyticalFramework.mainTitle.normalText2}
            </h4>
            <p className="mt-3 fs-5">
              {activeCard?.leftDescription ||
                "Every credit opportunity is evaluated using a rigorous multi-factor framework designed to identify strong issuers and protect investor capital. Our process covers:"}
            </p>
          </div>
          <div className="col-12 col-md-7 col-lg-8">
            <div className="row g-4 justify-content-center">
              {safeAnalyticalFramework.cards.map((card) => (
                <div
                  className="col-12 col-sm-6 col-lg-4"
                  key={card.id}
                  onClick={() => handleCardClick(card)}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className={`p-4 h-100 d-flex flex-column justify-content-between`}
                    style={
                      activeCard?.id === card.id
                        ? {
                            background: "#F47024",
                            color: "white",
                            cursor: "pointer",
                          }
                        : {
                            background: "rgba(244,112,36,0.1)",
                            cursor: "pointer",
                            color: "#F47024",
                          }
                    }
                  >
                    <h5 className="fs-4 fw-bold">{card.title}</h5>
                    <p className="fs-5 mb-0">{card.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer / Call to Action */}
        <div className="row">
          <div className="col-12">
            <div className="border boredr-color-wrapper p-2 text-center">
              <p className="mb-0 fs-4 text-capitalize">
                {safeAnalyticalFramework.footerText}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Investment Strategy Section */}
      <div className="col-11 m-auto mt-4">
        <p className="fs-1 fw-bold" data-aos="fade-up">
          {safeInvestmentStrategy.title.normalText}
          <span className="org">
            {safeInvestmentStrategy.title.highlightedText}
          </span>
          {safeInvestmentStrategy.title.normalText2}
        </p>

        <div className="row">
          <div className="col-lg-5 col-xl-6">
            <div className="col-11 m-auto row">
              {safeInvestmentStrategy.strategies.map((strategy, index) => (
                <div key={index} className="col-sm-6 mt-4" data-aos="fade-up">
                  <Link
                    activeClass="active"
                    to="points"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                    style={{ textDecoration: "none" }}
                  >
                    <div className="bg-card-box-color p-3 d-flex align-items-center justify-content-center">
                      <div className="my-3 text-center">
                        <p className="fs-4 fw-bold">
                          {strategy.title1 || strategy.title}
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-7 col-xl-6">
            <div className="text-start points">
              <p className="fs-1 fw-bold mt-3 text-center aos-init aos-animate">
                {safeInvestmentStrategy.conclusionBox.title}
              </p>
              <p className="fs-5 tJustify text-center aos-init aos-animate">
                {safeInvestmentStrategy.conclusionBox.description}
              </p>
              <div className="border d-flex flex-column gap-4 p-5 boredr-color-wrapper mt-5">
                <div>
                  <p className="fs-4 text-center">
                    {safeInvestmentStrategy.conclusionBox.text1}
                  </p>
                  <p className="fs-4 text-center fst-italic">
                    {safeInvestmentStrategy.conclusionBox.text2}
                  </p>
                </div>
                <p className="fs-4 text-center">
                  {safeInvestmentStrategy.conclusionBox.text3}
                </p>
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    className="buttonEffect"
                    data-aos="fade-up"
                    onClick={() => navigate("/about-us")}
                  >
                    {safeInvestmentStrategy.conclusionBox.buttonText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <WhyChose data={safeWhyChooseSection} />
      <Testimonial />

      {/* Blogs Section */}
      <div className="mt-4">
        <div className="col-11 m-auto text-start">
          <p className="fs-5" data-aos="fade-up">
            Updates
          </p>
          <p className="fs-1 fw-semibold" data-aos="fade-up">
            The latest from{" "}
          </p>
          <p className="fs-1 fw-bold org line-height-1 mb-2" data-aos="fade-up">
            Ladderup
          </p>
          <div className="d-flex gap-3" data-aos="fade-up"></div>
        </div>
        <div data-aos="fade-up">
          <BlogsSlider data={blogs} />
        </div>
      </div>
    </div>
  );
};

export default OpportunitiesPortfolio;
